import React, { useEffect, useState } from 'react';
import TextWinds from '../common/TextWinds';
import { useAppDispatch, useAppSelector } from '../../store/hook';
import {
  getOrdererInfo,
  selectOrderInfo,
} from '../../store/features/orderInfoSlice';
import { phoneFormat } from '../../api/utils/format/numbers';

/**
 * 결제 페이지 - 주문자 정보 컴포넌트
 */
const OrdererInfo = React.memo(() => {
  const dispatch = useAppDispatch();
  const orderer = useAppSelector(selectOrderInfo);

  useEffect(() => {
    dispatch(getOrdererInfo({ url: '' }));
  }, []);

  return (
    <div className="flex flex-col gap-2 rounded-md bg-white p-6">
      <TextWinds type="title_h4">주문자 정보</TextWinds>
      <div className="flex items-center">
        <div className="mr-auto">
          <TextWinds type="content">
            {orderer ? (
              `${orderer?.name} ( ${phoneFormat(orderer?.phone)} )`
            ) : (
              <>주문자 정보가 없습니다.</>
            )}
          </TextWinds>
        </div>
      </div>
    </div>
  );
});

export default OrdererInfo;
